import * as React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { cn } from '../../../utils/cn.utils'

interface RowProps {
  id: string
  children: React.ReactNode
}

export default function DraggableRow({ id, children }: RowProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id })

  const style = {
    transform: isDragging ? CSS.Transform.toString(transform) : undefined,
    transition,
    zIndex: isDragging ? 100 : 'auto',
    position: 'relative' as const,
  }

  // tbody에 ref와 style을 입혀서 내부의 모든 tr이 같이 움직이게 합니다.
  return (
    <tbody
      id={id}
      ref={setNodeRef}
      style={style}
      className={cn(
        isDragging ? 'opacity-50 shadow-lg' : '',
        'transition-colors',
      )}
    >
      {/* 첫 번째 자식(첫 번째 tr)에만 드래그 핸들(listeners)을 넣기 위해 처리 */}
      {React.Children.map(children, (child, index) => {
        if (index === 0 && React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<any>, {
            ...attributes,
            ...listeners, // 핸들을 첫 줄 전체 혹은 특정 td에만 줄 수 있습니다.
          })
        }
        return child
      })}
    </tbody>
  )
}
